import React from 'react';
import classNames from 'classnames';
import styles from './styles.css';

export default class Success extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const width = window.innerWidth;
        const scale = width / 1920;
        const height = window.innerHeight / scale;
        let year = (new Date()).getFullYear() + '';
        const y1 = year.substring(0, 1);
        const y2 = year.substring(1, 2);
        const y3 = year.substring(2, 3);
        const y4 = year.substring(3, 4);
        let data = this.props.data ? this.props.data : {code: '1'};

        let image = data.image || null;
        let hasPhoto = data.hasPhoto;

        //code:1:不是今年的迎新的学生，2：已经报到，3：报到成功
        //xsid:学生ID,xb：性别,xm：姓名，xy：学院，zy：专业
        return (
            <div style={{width, height: height * scale, overflow: 'hidden'}}>
                <div
                    style={{
                        width: 1920,
                        height,
                        transformOrigin: '0% 0%',
                        transform: `scale(${scale})`
                    }}
                    className={styles.box}
                >
                    <img
                        className={styles.logo}
                        src={require('./images/logo.png')}
                    />
                    <div className={styles.title_box}>
                        <div className={classNames('justify', styles.title_1)}>
                            N O W {y1} {y2} {y3} {y4}
                        </div>
                        <div className={classNames('justify', styles.title_2)}>
                            就 现 在
                        </div>
                        <div className={classNames('justify', styles.title_3)}>
                            遇 见 未 来
                        </div>
                    </div>
                    <div className={styles.box_con}>
                        <div className={styles.circle}>
                            <div className={styles.circle_con}>
                                <div className={styles.photo}>
                                    <div className={styles.head}>
                                        {
                                            data.code == '1' ? <img src={require('./images/tou.jpg')} width="93" height="127"/> :
                                                hasPhoto ? <img src={'api/sm-student//openapi/getStudentPhoto?xsid=' + data.xsid+'&type=10'} error={require('./images/tou.jpg')} width="93" height="127"/>
                                                    : (null != image) ? <img src={'data:image/jpeg;base64,' + image} error={require('./images/tou.jpg')} width="93" height="127"/> :
                                                    <img src={require('./images/tou.jpg')} width="93" height="127"/>
                                        }
                                    </div>
                                </div>
                                <div>
                                    <div className={styles.name}>
                                        {
                                            data.code != '1' ? (data.xm + '同学') : ''
                                        }
                                    </div>
                                    <div className={styles.xb}>
                                        {
                                            data.code != '1' ? (
                                                data.xb == '1' ? <img src={require('./images/male.png')}/> : <img src={require('./images/female.png')}/>
                                            ) : ''
                                        }
                                    </div>
                                </div>
                                <div className={styles.zy}>
                                    {
                                        data.code != '1' ? (
                                            data.xy + ' | ' + data.zy
                                        ) : ''
                                    }
                                </div>
                                {
                                    data.code == '1' ? <div className={styles.tip} style={{fontSize: '30px'}}>很遗憾，您不是我校的新生！</div> : ''
                                }
                                {
                                    data.code == '2' ? <div className={styles.tip} style={{fontSize: '30px'}}>您已报到，不需要再次报到！</div> : ''
                                }
                                {
                                    data.code == '3' ? <div className={styles.tip}>恭喜您，报到成功啦！</div> : ''
                                }
                            </div>
                        </div>
                        <div className={styles.shape}>
                            您好，您充值的大学time已到账，请查收。
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/face/success/index.js